<script>
  import { onMount } from 'svelte'
  import { form } from 'svelte-forms'
  import axios from 'axios'
  import _ from 'lodash'
  import { gsap, ScrollToPlugin, ScrollTrigger} from 'gsap/all'
  import { Circle } from 'svelte-loading-spinners'
  import Input from './components/Input.svelte'
  import Select from './components/Select.svelte'
  import getParams from './utils/getParams'
  import getReferrerDomain from './utils/getReferrerDomain'
  import getCountries from './utils/getCountries'
  import CountriesList from './countries'
  export let region
  
  const local = getReferrerDomain(window.location.href)
  const referrer = getReferrerDomain(document.referrer)
  const cParameterOrganic = getParams(window.location.href).c ? getParams(window.location.href).c : 'FAC230DDS00'
  const campaignCode = getParams(window.location.href).c ? getParams(window.location.href).c : (local === referrer ? 'COR250DS505' : 'CORI25DS500')
  const countries = getCountries()
  const CountriesData = CountriesList();

  const setInitialState = async () => {
    if(window.location.href.indexOf('/int') !== -1) {
      defaultRegion = false
    } else if (window.location.href.indexOf('/ec') !== -1) {
      defaultRegion = { value: 'EC', label:'Ecuador', }
    } else {
      defaultRegion = { value: 'ES', label:'España', }
    }
  }

  // JSON update country info
  const updateCountryInfo = () => {
    lead_province = ''
    lead_provinces = [];
    if(lead_countryISO !== ''){
      lead_provinces = Object.entries(CountriesData[lead_countryISO].states).map(([key, val]) => (
        {
          value: key, 
          label: val
        }
      ));
    }
  }

  onMount(async () => {
    document.querySelectorAll('.faculties-item a').forEach(a => {
      a.href = a.href + '?c=' + cParameterOrganic
    })

    document.querySelectorAll('.acordion a').forEach(a => {
      a.href = a.href + '?c=' + campaignCode
    })
    updateCountryInfo();
    setInitialState();
	})
  

  const GRADES = [
      {
        value: 1,
        label: 'Artes y Humanidades',
      },
      {
        value: 2,
        label: 'Ciencia y Tecnología',
      },
      {
        value: 3,
        label: 'Ciencias de la Salud',
      },
      {
        value: 4,
        label: 'Comunicación',
      },
      {
        value: 5,
        label: 'Educación',
      },
      {
        value: 6,
        label: 'Empresa',
      },
      {
        value: 7,
        label: 'Jurídico',
      },
    ]

    const PROGRAMS = [
    { type: 'grados', label: 'Grado en Historia', value: 3257, group: 1, },
    { type: 'grados', label: 'Grado en Humanidades', value: 2505, group: 1, },
    { type: 'grados', label: 'Grado en Musicología', value: 340, group: 1, },
    { type: 'grados', label: 'Grado en Traducción e Interpretación', value: 72, group: 1, },
    { type: 'grados', label: 'Grado en Lengua y Literatura**', value: 528, group: 1, },
    { type: 'masteres', label: 'Máster Universitario en Composición Musical', value: 466, group: 1, },
    { type: 'masteres', label: 'Máster Universitario en Gestión del Patrimonio Cultural y Museología', value: 433, group: 1, },
    { type: 'masteres', label: 'Máster Universitario en Interpretación e Investigación Musical', value: 57, group: 1, },
    { type: 'masteres', label: 'Máster Universitario en Traducción Editorial con Grupo Planeta', value: 463, group: 1, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Creación Literaria con Grupo Planeta', value: 327, group: 1, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Edición y Gestión Editorial con Grupo Planeta', value: 438, group: 1, },
    { type: 'cursos', label: 'Experto Universitario en Escritura, Estilo y Creatividad', value: 392, group: 1, },

    { type: 'grados', label: 'Grado en Ingeniería en Organización Industrial', value: 308, group: 2, },
    { type: 'grados', label: 'Grado en Ingeniería Informática', value: 73, group: 2, },
    { type: 'grados', label: 'Grado en Matemáticas', value: 430, group: 2, },
    { type: 'grados', label: 'Grado en Ciencia de Datos e Inteligencia Artificial', value: 520, group: 2, },
    { type: 'grados', label: 'Grado en Física', value: 505, group: 2, },
    { type: 'grados', label: 'Grado en Ciberseguridad**', value: 524, group: 2, },
    { type: 'grados', label: 'Grado en Ingeniería de Tecnologías y Servicios de Telecomunicación**', value: 523, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Astronomía y Astrofísica', value: 56, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Big Data y Ciencia de Datos', value: 105, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Ciberseguridad', value: 93, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Desarrollo de Aplicaciones y Servicios Web', value: 458, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Energías Renovables', value: 316, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Industria 4.0', value: 431, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Ingeniería Biomédica', value: 314, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Ingeniería y Gestión Ambiental', value: 471, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Inteligencia Artificial', value: 311, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Robótica y Automatización de Procesos', value: 503, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Ingeniería en Organización Industrial', value: 515, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Ingeniería Industrial', value: 504, group: 2, },
    { type: 'masteres', label: 'Máster Universitario en Gestión de las Tecnologías de la Información y la Comunicación', value: 514, group: 2, },
    { type: 'masteres', label: 'Master de Formación Permanente en Programación Web asistida por IA', value: 549, group: 2, },
    { type: 'masteres', label: 'Master de Formación Permanente en Data Analitycs', value: 558, group: 2, },
    { type: 'masteres', label: 'Master de Formación Permanente en Desarrollo Ágil de Sofware y DevOPS', value: 543, group: 2, },
    { type: 'masteres', label: 'Master de Formación Permanente en Ciudades Inteligentes y sostenibles', value: 544, group: 2, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Realidad Extendida: virtual, aumentada y mixta', value: 545, group: 2, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Gestión de la Seguridad Informática', value: 552, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Astronomía Observacional', value: 432, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Programación en Python', value: 457, group: 2, },
    { type: 'cursos', label: 'Programa de Doctorado en Ciencia de Datos y Big Data', value: 536, group: 2, },

    { type: 'grados', label: 'Grado en Psicología', value: 11, group: 3, },
    { type: 'grados', label: 'Grado en Logopedia', value: 429, group: 3, },
    { type: 'grados', label: 'Grado en Nutrición Humana y Dietética', value: 541, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Bioética', value: 321, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Bioinformática', value: 461, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Ciencias Avanzadas de la Nutrición Humana', value: 341, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Cuidados de Enfermería en Urgencias y Emergencias', value: 468, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Cuidados de Enfermería en Reanimación y Medicina Intensiva', value: 512, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Dirección Sanitaria y Gestión Clínica', value: 460, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Dirección y Gestión de Enfermería', value: 395, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Epidemiología y Salud Pública', value: 307, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Gerontología y Atención Centrada en la Persona', value: 80, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Neurociencia e Investigación en Imagen Neurológica*', value: 506, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Neuropsicología Clínica', value: 100, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Nutrición y Salud', value: 78, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Prevención en Drogrodependencias y otras Conductas Adictivas', value: 305, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Prevención e Intervención Psicológica en Problemas de Conducta en la Escuela', value: 51, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Psicología de la Educación**', value: 532, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Psicología en la Infancia y Adolescencia', value: 459, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Psicología de la Intervención Social y Comunitaria', value: 469, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Psicología Jurídica', value: 402, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Terapias Psicológicas de Tercera Generación', value: 52, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Trabajo Social en el Ámbito Sanitario', value: 477, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Fisioterapia Neurológica', value: 322, group: 3, },
    { type: 'masteres', label: 'Máster Universitario en Psicología General Sanitaria', value: 52, group: 3, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Nutrición Deportiva', value: 521, group: 3, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Inmunoterapia y Vacunas', value: 522, group: 3, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Fisioterapia Deportiva y Ejercicio Terapéutico', value: 542, group: 3, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Nutrición y Alimentación Saludable ', value: 548, group: 3, },
    { type: 'masteres', label: 'Programa de Doctorado en Inmunonutrición, Genómica Nutricional y Alimentación', value: 513, group: 3, },
    { type: 'masteres', label: 'Programa de Doctorado en Salud Pública, Comunitaria y Adicciones', value: 537, group: 3, },

    { type: 'grados', label: 'Grado en Comunicación', value: 331, group: 4, },
    { type: 'masteres', label: 'Máster Universitario en Comunidación Corporativa y Estratégica', value: 434, group: 4, },
    { type: 'masteres', label: 'Máster Universitario en Comunicación Social y Cultural para los desafíos Contemporáneos', value: 502, group: 4, },
    { type: 'masteres', label: 'Máster Universitario en Comunicación Social de la Investigación Científica', value: 55, group: 4, },
    { type: 'masteres', label: 'Máster Universitario en Comunicación y Marketing Político', value: 467, group: 4, },
    { type: 'masteres', label: 'Máster Universitario en Periodismo Multimedia', value: 407, group: 4, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Protocolo, Comunicación y Gestión de Eventos', value: 534, group: 4, },

    { type: 'grados', label: 'Grado en Educación Infantil', value: 10, group: 5, },
    { type: 'grados', label: 'Grado en Educación Primaria', value: 12, group: 5, },
    { type: 'grados', label: 'Grado en Pedagogía', value: 428, group: 5, },
    { type: 'grados', label: 'Grado en Educación Social**', value: 526, group: 5, },
    { type: 'grados', label: 'Mención en Educación Musical (Educación Primaria)', value: 1411, group: 5, },
    { type: 'grados', label: 'Mención en Lengua Extranjera (Educación Primaria)', value: 1413, group: 5, },
    { type: 'grados', label: 'Mención en TIC en Educación (Educación Primaria)', value: 1415, group: 5, },
    { type: 'grados', label: 'Mención en Pedagogía Terapéutica (Educación Primaria)', value: 556, group: 5, },
    { type: 'grados', label: 'Mención en Educación Física (Educación Primaria)', value: 555, group: 5, },
    { type: 'grados', label: 'Mención en Audición y lenguajes (Educación Primaria)', value: 554, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Acoso Escolar y Medicación', value: 335, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Dificultades de Aprendizaje y Trastornos de la Comunicación en Contextos Socioeducativos', value: 474, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Dirección, Liderazgo y Gestión de Centros Educativos', value: 476, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Educación Bilingüe', value: 336, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Enseñanza de Español como Lengua Extranjera', value: 326, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Formación del Profesorado de Educación Secundaria Obligatoria, Bachillerato, Formación Profesional y Enseñanza de Idiomas', value: 50, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Investigación en Educación', value: 507, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Necesidades Educativas Especiales y Atención Temprana', value: 75, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Psicopedagogía', value: 201, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Tecnologías de la Información y la Comunicación Aplicadas a Educación', value: 104, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Metodologías Activas y Digitales', value: 508, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Didáctica de las Matemáticas', value: 535, group: 5, },
    { type: 'masteres', label: 'Máster Universitario en Educación Inclusiva y Atención a la Diversidad*', value: 527, group: 5, },

    { type: 'grados', label: 'Grado en Administración y Dirección de Empresas (ADE)',	value: 455, group: 6, },
    { type: 'grados', label: 'Grado en Marketing', value: 329, group: 6, },
    { type: 'grados', label: 'Grado en Relaciones Laborales y Recursos Humanos', value: 501, group: 6, },
    { type: 'grados', label: 'Grado en Gestión Logística y Transporte',	value: 517, group: 6, },
    { type: 'grados', label: 'Grado en Finanzas y Contabilidad',	value: 533, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Administración y Dirección de Empresas (MBA)',	value: 77, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Dirección de Marketing y Gestión Comercial',	value: 332, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Dirección y Gestión Financiera',	value: 470, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Dirección y Gestión de Personas',	value: 462, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Economía Circular y Desarrollo Sostenible',	value: 440, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Gestión Deportiva',	value: 328, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Gestión de la Cadena de Suminsitro y Logística / Supply Chain Management and Logistics',	value: 401, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Gestión de Proyectos / Project Management',	value: 333, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Prevención de Riesgos Laborales',	value: 86, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Gestión Integral de la Calidad',	value: 397, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Marketing Digital y Analítico',	value: 441, group: 6, },
    { type: 'masteres', label: 'Máster Universitario en Inteligencia de Negocio**',	value: 516, group: 6, },
    { type: 'masteres', label: 'Máster en Formación Permanente IA Transformación de Negocio',	value: 546, group: 6, },
    { type: 'masteres', label: 'Máster de Formación Permanente  en Estrategias de Transformación Sostenible y Reporting ESG',	value: 553, group: 6, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Gestión Ágil y Sostenible de Proyectos',	value: 550, group: 6, },
    { type: 'masteres', label: 'Máster de Formación Permanente en Inteligencia Artificial  aplicada a  las finanzas',	value: 539, group: 6, },

    { type: 'grados', label: 'Grado en Derecho',	value: 15, group: 7, },
    { type: 'grados', label: 'Grado en Relaciones Internacionales',	value: 81, group: 7, },
    { type: 'grados', label: 'Grado en Criminología y Ciencias de la Seguridad',	value: 325, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Abogacía y Práctica Jurídica',	value: 53, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Criminología: Delincuencia y Victimología',	value: 74, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Derecho Digital y de la Ciberseguridad',	value: 510, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Derecho de los Negocios y la Contratación Internacionales',	value: 472, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Intervención Interdisciplinar en Violencia de Género',	value: 304, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Mediación y Gestión del Conflicto',	value: 85, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Propiedad Intelectual e Industrial',	value: 394, group: 7, },
    { type: 'masteres', label: 'Máster Universitario en Fiscalidad Internacional',	value: 518, group: 7, },
  ]

  const PROGRAMS_LAT = [
    { type: 'grados', label: 'Pregrado en Historia', value: 3257, group: 1, },
    { type: 'grados', label: 'Pregrado en Humanidades', value: 2505, group: 1, },
    { type: 'grados', label: 'Pregrado en Musicología', value: 340, group: 1, },
    { type: 'grados', label: 'Pregrado en Traducción e Interpretación', value: 72, group: 1, },
    { type: 'grados', label: 'Pregrado en Lengua y Literatura Españolas*', value: 528, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Composición Musical', value: 466, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión del Patrimonio Cultural y Museología', value: 433, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Interpretación e Investigación Musical', value: 57, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Traducción Editorial con Grupo Planeta', value: 463, group: 1, },
    { type: 'masteres', label: 'Maestría en Creación Literaria con Grupo Planeta', value: 327, group: 1, },
    { type: 'masteres', label: 'Maestría en Edición y Gestión Editorial con Grupo Planeta', value: 438, group: 1, },
    { type: 'cursos', label: 'Experto Oficial en Escritura, Estilo y Creatividad', value: 392, group: 1, },

    { type: 'grados', label: 'Pregrado en Ingeniería en Organización Industrial', value: 308, group: 2, },
    { type: 'grados', label: 'Pregrado en Ingeniería Informática', value: 73, group: 2, },
    { type: 'grados', label: 'Pregrado en Matemáticas', value: 430, group: 2, },
    { type: 'grados', label: 'Pregrado en Ciencia de Datos e Inteligencia Artificial', value: 520, group: 2, },
    { type: 'grados', label: 'Pregrado en Física', value: 505, group: 2, },
    { type: 'grados', label: 'Pregrado en Ciberseguridad**', value: 524, group: 2, },
    { type: 'grados', label: 'Pregrado en Ingeniería de Tecnologías y Servicios de Telecomunicación*', value: 523, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Astronomía y Astrofísica', value: 56, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Big Data y Ciencia de Datos', value: 105, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ciberseguridad', value: 93, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Desarrollo de Aplicaciones y Servicios Web', value: 458, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Energías Renovables', value: 316, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Industria 4.0', value: 431, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ingeniería Biomédica', value: 314, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ingeniería y Gestión Ambiental', value: 471, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Inteligencia Artificial', value: 311, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Robótica y Automatización de Procesos*', value: 503, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ingeniería en Organización Industrial', value: 515, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de las Tecnologías de la Información y la Comunicación', value: 514, group: 2, },
    { type: 'masteres', label: 'Maestría DevOps', value: 543, group: 2, },
    { type: 'masteres', label: 'Maestría en Ciudades Inteligentes y Sostenibles', value: 544, group: 2, },
    { type: 'masteres', label: 'Maestría en Realidad Extendida: Virtual, Aumentada y Mixta', value: 545, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Astronomía Observacional', value: 432, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Programación en Python', value: 457, group: 2, },

    { type: 'grados', label: 'Pregrado en Psicología', value: 11, group: 3, },
    { type: 'grados', label: 'Pregrado en Logopedia', value: 429, group: 3, },
    { type: 'grados', label: 'Pregrado en Nutrición Humana y Dietética**', value: 541, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Bioética', value: 321, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Bioinformática', value: 461, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Ciencias Avanzadas de la Nutrición Humana', value: 341, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Cuidados de Enfermería en Urgencias y Emergencias', value: 468, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Cuidados de Enfermería en Reanimación y Medicina Intensiva', value: 512, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección Sanitaria y Gestión Clínica', value: 460, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión de Enfermería', value: 395, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Epidemiología y Salud Pública', value: 307, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Gerontología y Atención Centrada en la Persona', value: 80, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Neurociencia e Investigación en Imagen Neurológica**', value: 506, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Neuropsicología Clínica', value: 100, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Nutrición y Salud', value: 78, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención en Drogrodependencias y otras Conductas Adictivas', value: 305, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención e Intervención Psicológica en Problemas de Conducta en la Escuela', value: 51, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología de la Educación**', value: 532, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología en la Infancia y Adolescencia', value: 459, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología de la Intervención Social y Comunitaria', value: 469, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología Jurídica', value: 402, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Terapias Psicológicas de Tercera Generación', value: 52, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Trabajo Social en el Ámbito Sanitario', value: 477, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Fisioterapia Neurológica', value: 322, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Nutrición y Salud', value: 78, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Epidemiología y Salud Pública', value: 518, group: 3, },
    { type: 'masteres', label: 'Maestría en Nutrición Deportiva', value: 521, group: 3, },
    { type: 'masteres', label: 'Maestría en Inmunoterapia y Vacunas', value: 522, group: 3, },
    { type: 'masteres', label: 'Maestría en Fisioterapia Deportiva y Ejercicio Terapéutico', value: 542, group: 3, },

    { type: 'grados', label: 'Pregrado en Comunicación', value: 331, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Corporativa y Estratégica', value: 434, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Social y Cultural para los desafíos Contemporáneos', value: 502, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Social de la Investigación Científica', value: 55, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación y Marketing Político', value: 467, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Periodismo Multimedia', value: 407, group: 4, },
    { type: 'masteres', label: 'Maestría en Protocolo, Comunicación y Gestión de Eventos', value: 534, group: 4, },

    { type: 'grados', label: 'Pregrado en Educación Infantil', value: 10, group: 5, },
    { type: 'grados', label: 'Pregrado en Educación Primaria', value: 12, group: 5, },
    { type: 'grados', label: 'Pregrado en Pedagogía', value: 428, group: 5, },
    { type: 'grados', label: 'Pregrado en Educación Social**', value: 526, group: 5, },
    { type: 'grados', label: 'Mención en Educación Musical (Educación Primaria)', value: 1411, group: 5, },
    { type: 'grados', label: 'Mención en Lengua Extranjera (Educación Primaria)', value: 1413, group: 5, },
    { type: 'grados', label: 'Mención en TIC en Educación (Educación Primaria)', value: 1415, group: 5, },
    { type: 'grados', label: 'Mención en Pedagogía Terapéutica (Educación Primaria)', value: 556, group: 5, },
    { type: 'grados', label: 'Mención en Educación Física (Educación Primaria)', value: 555, group: 5, },
    { type: 'grados', label: 'Mención en Audición y lenguajes (Educación Primaria)', value: 554, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Acoso Escolar y Mediación', value: 335, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Dificultades de Aprendizaje y Trastornos de la Comunicación en Contextos Socioeducativos', value: 474, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección, Liderazgo y Gestión de Centros Educativos', value: 476, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Educación Bilingüe', value: 336, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Enseñanza de Español como Lengua Extranjera', value: 326, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Investigación en Educación', value: 507, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Necesidades Educativas Especiales y Atención Temprana', value: 75, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Psicopedagogía', value: 201, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Tecnologías de la Información y la Comunicación Aplicadas a Educación', value: 104, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Metodologías Activas y Digitales', value: 508, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Didáctica de las Matemáticas', value: 535, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Educación Inclusiva y Atención a la Diversidad**', value: 527, group: 5, },

    { type: 'grados', label: 'Pregrado en Administración y Dirección de Empresas (ADE)', value: 455, group: 6, },
    { type: 'grados', label: 'Pregrado en Marketing',	value: 329, group: 6, },
    { type: 'grados', label: 'Pregrado en Relaciones Laborales y Recursos Humanos', value: 501, group: 6, },
    { type: 'grados', label: 'Pregrado en Gestión Logística y Transporte*',	value: 517, group: 6, },
    { type: 'grados', label: 'Pregrado en Finanzas y Contabilidad',	value: 533, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Administración y Dirección de Empresas (MBA)',	value: 77, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección de Marketing y Gestión Comercial',	value: 332, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión Financiera',	value: 470, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión de Personas',	value: 462, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Economía Circular y Desarrollo Sostenible',	value: 440, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión Deportiva',	value: 328, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de la Cadena de Suminsitro y Logística / Supply Chain Management and Logistics',	value: 401, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de Proyectos / Project Management',	value: 333, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención de Riesgos Laborales',	value: 86, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión Integral de la Calidad',	value: 397, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Marketing Digital y Analítico',	value: 441, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Inteligencia de Negocio*',	value: 516, group: 6, },
    { type: 'masteres', label: 'Maestría IA Transformación de Negocio',	value: 546, group: 6, },
    { type: 'masteres', label: 'Maestría IA aplicada a las Finanzas',	value: 547, group: 6, },

    { type: 'grados', label: 'Pregrado en Relaciones Internacionales',	value: 81, group: 7, },
    { type: 'grados', label: 'Pregrado en Criminología y Ciencias de la Seguridad',	value: 325, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Abogacía y Práctica Jurídica',	value: 53, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Criminología: Delincuencia y Victimología',	value: 74, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Derecho Digital y de la Ciberseguridad',	value: 510, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Derecho de los Negocios y la Contratación Internacionales',	value: 472, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Intervención Interdisciplinar en Violencia de Género',	value: 304, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Mediación y Gestión del Conflicto',	value: 85, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Propiedad Intelectual e Industrial',	value: 394, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Fiscalidad Internacional',	value: 518, group: 7, },
  ]

  const PROGRAMS_EC = [
    { type: 'grados', label: 'Pregrado en Historia', value: 3257, group: 1, },
    { type: 'grados', label: 'Pregrado en Humanidades', value: 2505, group: 1, },
    { type: 'grados', label: 'Pregrado en Musicología', value: 340, group: 1, },
    { type: 'grados', label: 'Pregrado en Traducción e Interpretación', value: 72, group: 1, },
    { type: 'grados', label: 'Pregrado en Lengua y Literatura Españolas*', value: 528, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Composición Musical', value: 466, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión del Patrimonio Cultural y Museología', value: 433, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Interpretación e Investigación Musical', value: 57, group: 1, },
    { type: 'masteres', label: 'Maestría Oficial en Traducción Editorial con Grupo Planeta', value: 463, group: 1, },
    { type: 'masteres', label: 'Maestría en Creación Literaria con Grupo Planeta', value: 327, group: 1, },
    { type: 'masteres', label: 'Maestría en Edición y Gestión Editorial con Grupo Planeta', value: 438, group: 1, },
    { type: 'cursos', label: 'Experto Oficial en Escritura, Estilo y Creatividad', value: 392, group: 1, },

    { type: 'grados', label: 'Pregrado en Ingeniería en Organización Industrial', value: 308, group: 2, },
    { type: 'grados', label: 'Pregrado en Ingeniería Informática', value: 73, group: 2, },
    { type: 'grados', label: 'Pregrado en Matemáticas', value: 430, group: 2, },
    { type: 'grados', label: 'Pregrado en Ciencia de Datos e Inteligencia Artificial', value: 520, group: 2, },
    { type: 'grados', label: 'Pregrado en Física', value: 505, group: 2, },
    { type: 'grados', label: 'Pregrado en Ciberseguridad**', value: 524, group: 2, },
    { type: 'grados', label: 'Pregrado en Ingeniería de Tecnologías y Servicios de Telecomunicación*', value: 523, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Astronomía y Astrofísica', value: 56, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Big Data y Ciencia de Datos', value: 105, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ciberseguridad', value: 93, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Desarrollo de Aplicaciones y Servicios Web', value: 458, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Energías Renovables', value: 316, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Industria 4.0', value: 431, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ingeniería y Gestión Ambiental', value: 471, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Inteligencia Artificial', value: 311, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Robótica y Automatización de Procesos*', value: 503, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Ingeniería en Organización Industrial*', value: 515, group: 2, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de las Tecnologías de la Información y la Comunicación', value: 514, group: 2, },
    { type: 'masteres', label: 'Maestría DevOps', value: 543, group: 2, },
    { type: 'masteres', label: 'Maestría en Ciudades Inteligentes y Sostenibles', value: 544, group: 2, },
    { type: 'masteres', label: 'Maestría en Realidad Extendida: Virtual, Aumentada y Mixta', value: 545, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Astronomía Observacional', value: 432, group: 2, },
    { type: 'cursos', label: 'Diploma Especialista en Programación en Python', value: 457, group: 2, },

    { type: 'grados', label: 'Pregrado en Psicología', value: 11, group: 3, },
    { type: 'grados', label: 'Pregrado en Logopedia', value: 429, group: 3, },
    { type: 'grados', label: 'Pregrado en Nutrición Humana y Dietética**', value: 541, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Bioética', value: 321, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Bioinformática', value: 461, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Ciencias Avanzadas de la Nutrición Humana', value: 341, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Cuidados de Enfermería en Urgencias y Emergencias', value: 468, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Cuidados de Enfermería en Reanimación y Medicina Intensiva', value: 512, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección Sanitaria y Gestión Clínica', value: 460, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión de Enfermería', value: 395, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Neurociencia e Investigación en Imagen Neurológica**', value: 506, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Neuropsicología Clínica', value: 100, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención en Drogrodependencias y otras Conductas Adictivas', value: 305, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención e Intervención Psicológica en Problemas de Conducta en la Escuela', value: 51, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología en la Infancia y Adolescencia', value: 459, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología de la Intervención Social y Comunitaria', value: 469, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Psicología Jurídica', value: 402, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Terapias Psicológicas de Tercera Generación', value: 52, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Trabajo Social en el Ámbito Sanitario', value: 477, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Fisioterapia Neurológica', value: 322, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Nutrición y Salud', value: 78, group: 3, },
    { type: 'masteres', label: 'Maestría Oficial en Epidemiología y Salud Pública', value: 518, group: 3, },
    { type: 'masteres', label: 'Maestría en Nutrición Deportiva', value: 521, group: 3, },
    { type: 'masteres', label: 'Maestría en Inmunoterapia y Vacunas', value: 522, group: 3, },
    { type: 'masteres', label: 'Maestría en Fisioterapia Deportiva y Ejercicio Terapéutico', value: 542, group: 3, },

    { type: 'grados', label: 'Pregrado en Comunicación', value: 331, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Corporativa y Estratégica', value: 434, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Social y Cultural para los desafíos Contemporáneos', value: 502, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación Social de la Investigación Científica', value: 55, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Comunicación y Marketing Político', value: 467, group: 4, },
    { type: 'masteres', label: 'Maestría Oficial en Periodismo Multimedia', value: 407, group: 4, },
    { type: 'masteres', label: 'Maestría en Protocolo, Comunicación y Gestión de Eventos', value: 534, group: 4, },

    { type: 'grados', label: 'Pregrado en Educación Infantil', value: 10, group: 5, },
    { type: 'grados', label: 'Pregrado en Educación Primaria', value: 12, group: 5, },
    { type: 'grados', label: 'Pregrado en Pedagogía', value: 428, group: 5, },
    { type: 'grados', label: 'Pregrado en Educación Social**', value: 526, group: 5, },
    { type: 'grados', label: 'Mención en Educación Musical (Educación Primaria)', value: 1411, group: 5, },
    { type: 'grados', label: 'Mención en Lengua Extranjera (Educación Primaria)', value: 1413, group: 5, },
    { type: 'grados', label: 'Mención en TIC en Educación (Educación Primaria)', value: 1415, group: 5, },
    { type: 'grados', label: 'Mención en Pedagogía Terapéutica (Educación Primaria)', value: 556, group: 5, },
    { type: 'grados', label: 'Mención en Educación Física (Educación Primaria)', value: 555, group: 5, },
    { type: 'grados', label: 'Mención en Audición y lenguajes (Educación Primaria)', value: 554, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Acoso Escolar y Mediación', value: 335, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Dificultades de Aprendizaje y Trastornos de la Comunicación en Contextos Socioeducativos', value: 474, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección, Liderazgo y Gestión de Centros Educativos', value: 476, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Educación Bilingüe', value: 336, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Enseñanza de Español como Lengua Extranjera', value: 326, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Investigación en Educación', value: 507, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Necesidades Educativas Especiales y Atención Temprana', value: 75, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Psicopedagogía', value: 201, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Tecnologías de la Información y la Comunicación Aplicadas a Educación', value: 104, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Metodologías Activas y Digitales', value: 508, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Didáctica de las Matemáticas', value: 535, group: 5, },
    { type: 'masteres', label: 'Maestría Oficial en Educación Inclusiva y Atención a la Diversidad**', value: 527, group: 5, },

    { type: 'grados', label: 'Pregrado en Administración y Dirección de Empresas (ADE)', value: 455, group: 6, },
    { type: 'grados', label: 'Pregrado en Marketing',	value: 329, group: 6, },
    { type: 'grados', label: 'Pregrado en Relaciones Laborales y Recursos Humanos', value: 501, group: 6, },
    { type: 'grados', label: 'Pregrado en Gestión Logística y Transporte*',	value: 517, group: 6, },
    { type: 'grados', label: 'Pregrado en Finanzas y Contabilidad',	value: 533, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Administración y Dirección de Empresas (MBA)',	value: 77, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección de Marketing y Gestión Comercial',	value: 332, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión Financiera',	value: 470, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Dirección y Gestión de Personas',	value: 462, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Economía Circular y Desarrollo Sostenible',	value: 440, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión Deportiva',	value: 328, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de la Cadena de Suminsitro y Logística / Supply Chain Management and Logistics',	value: 401, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión de Proyectos / Project Management',	value: 333, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Prevención de Riesgos Laborales',	value: 86, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Gestión Integral de la Calidad',	value: 397, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Marketing Digital y Analítico',	value: 441, group: 6, },
    { type: 'masteres', label: 'Maestría Oficial en Inteligencia de Negocio*',	value: 516, group: 6, },
    { type: 'masteres', label: 'Maestría IA Transformación de Negocio',	value: 546, group: 6, },
    { type: 'masteres', label: 'Maestría IA aplicada a las Finanzas',	value: 547, group: 6, },

    { type: 'grados', label: 'Pregrado en Relaciones Internacionales',	value: 81, group: 7, },
    { type: 'grados', label: 'Pregrado en Criminología y Ciencias de la Seguridad',	value: 325, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Abogacía y Práctica Jurídica',	value: 53, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Criminología: Delincuencia y Victimología',	value: 74, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Derecho Digital y de la Ciberseguridad',	value: 510, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Derecho de los Negocios y la Contratación Internacionales',	value: 472, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Intervención Interdisciplinar en Violencia de Género',	value: 304, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Mediación y Gestión del Conflicto',	value: 85, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Propiedad Intelectual e Industrial',	value: 394, group: 7, },
    { type: 'masteres', label: 'Maestría Oficial en Fiscalidad Internacional',	value: 518, group: 7, },
  ]

  const SPECIALITIES = [
    { label: 'Máster U. Formación del Profesorado (Biología)',	value: 3375 },
    { label: 'Máster U. Formación del Profesorado (Dibujo)',	value: 3373 },
    { label: 'Máster U. Formación del Profesorado (Economía y Administración de Empresas)',	value: 3377 },
    { label: 'Máster U. Formación del Profesorado (Educación Física)',	value: 3366 },
    { label: 'Máster U. Formación del Profesorado (FOL)',	value: 3372 },
    { label: 'Máster U. Formación del Profesorado (Física y química)',	value: 3374 },
    { label: 'Máster U. Formación del Profesorado (Geografía e Historia)',	value: 3369 },
    { label: 'Máster U. Formación del Profesorado (Lengua extranjera Inglés)',	value: 3367 },
    { label: 'Máster U. Formación del Profesorado (Lengua y Literatura Española)',	value: 3368 },
    { label: 'Máster U. Formación del Profesorado (Matemáticas)',	value: 3365 },
    { label: 'Máster U. Formación del Profesorado (Música)',	value: 3371 },
    { label: 'Máster U. Formación del Profesorado (Orientación educativa)',	value: 3370 },
    { label: 'Máster U. Formación del Profesorado (Tecnología e Informática)',	value: 3376 },
  ]

  let grades = ''
  let program_idProduct = ''
  let program_idSpeciality = ''
  let lead_name = ''
  let lead_surname = ''
  let lead_email = ''
  let lead_sex = ''
  let lead_age = ''
  let lead_countryISO = ''
  let lead_province = ''
  let lead_provinces = []
  let lead_postCode = ''
  let lead_phoneNumber = ''
  let study_level = ''
  let loading = false
  let success = false
  let error = false
  let defaultRegion = false
  const requiredIfIdProduct = value => {
    if(value !== '' )return { valid: true , name: 'required' }
    return { valid: program_idProduct !== 50 , name: 'required' }
  }
  const leadForm = form(
    () => ({
      grades: {
        value: grades,
        validators: ["required"]
      },
      program_idProduct: {
        value: program_idProduct,
        validators: ["required"]
      },
      program_idSpeciality: {
        value: program_idSpeciality,
        validators: [requiredIfIdProduct]
      },
      lead_name: {
        value: lead_name,
        validators: ["required"]
      },
      lead_surname: {
        value: lead_surname,
        validators: ["required"]
      },
      lead_email: {
        value: lead_email,
        validators: ["required", "email"]
      },
      lead_sex: {
        value: lead_sex,
        validators: ["required"],
      },
      lead_age: {
        value: lead_age,
        validators: ["required"]
      },
      lead_countryISO: {
        value: lead_countryISO,
        validators: ["required"]
      },
      lead_province: {
        value: lead_province,
        validators: lead_provinces ? ["required"] : [],
      },
      lead_postCode: {
        value: lead_postCode,
        validators: ["required"],
      },
      lead_phoneNumber: {
        value: lead_phoneNumber,
        validators: ["required", value => {
          return {
            name: 'invalidPhone',
            valid: `${value}`.length >= 5 && `${value}`.length <= 15
          }
        }]
      },
      study_level: {
        value: study_level,
        validators: ["required"],
      },
    }),
    {
      initCheck: false,
      validateOnChange: false,
      stopAtFirstError: false,
      stopAtFirstFieldError: false
    }
  );
  //video interactions
  window.addEventListener("scroll",() => {
    const video = document.querySelector('#video');
    const rect = document.querySelector('#fold').getBoundingClientRect()
    const isInViewport = rect.top + rect.height > 0

    if(isInViewport && video.paused){
      video.play();
      video.style.visibility = null
      video.style.display = null
    }
    if(!isInViewport && !video.paused){
      video.pause();
      video.style.visibility = 'hidden'
      video.style.display = 'none'
    }
  });
  const videoModal = document.querySelector('#video-modal');
  const videoBig = document.querySelector('#video-big')
  document.getElementById('button-show-modal').addEventListener('click', () => {
    gsap.to(videoModal, {duration: 0.5, autoAlpha: 1, ease: 'power4.out', display: 'flex'})
    videoBig.play();
  })
  document.getElementById('close-modal-video').addEventListener('click', () => {
    const videoModal = document.querySelector('#video-modal');
    gsap.to(videoModal, {duration: 0.5, autoAlpha: 0, ease: 'power4.out', display: 'none'})
    videoBig.pause();
  })
  // scroll to
  gsap.registerPlugin(ScrollToPlugin)
  const scrollToForm = event => {
    event.preventDefault()
    const addSpace = document.getElementById('navheader').offsetHeight
    gsap.to(window, {duration: 1, scrollTo: {y: "#form", offsetY: addSpace}})
  }
  document.getElementById('moreInfoBtn').addEventListener('click', scrollToForm)
  document.getElementById('mobileMoreInfoBtn').addEventListener('click', scrollToForm)

  
  const scrollToAnchor = event => {
    event.preventDefault()
    const addSpace = window.innerWidth >= 768 ? 0 : document.getElementById('navheader').offsetHeight
    gsap.to(window, {duration: 1, scrollTo: {y: "#anchor", offsetY: addSpace}})
  }
  document.getElementById('toAnchor').addEventListener('click', scrollToAnchor)

  // animations
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.matchMedia({
    "(min-width:1280px)": () => {
      const scrollTrigger = {
        trigger: '#claim',
        start: 'top top',
        end: '+=500',
        scrub: true,
        // markers: {startColor: "blue", endColor: "blue", fontSize: "20px"}
      }
      gsap.timeline({
        scrollTrigger: {
          ...scrollTrigger,
          pin: true
        }
      })
      const timeline = gsap.timeline({scrollTrigger})
      for(let i = 1; i <= 9; i++){
        timeline.from(
          document.querySelectorAll(`.appear-text-${i}`),  {
            y: 50,
            opacity: 0,
          },
          i-1,
        )
        const image = document.querySelectorAll(`.appear-image-${i}`)
        if(image.length)
          timeline.from(
            image,{
              opacity: 0,
            },
            i-1,
          )
      } 
    }
  })

  const counterItems = document.querySelectorAll('.counter-animation')
  gsap.from(counterItems, {
    scrollTrigger: {
      trigger: counterItems,
      start: "top 80%"
    },
    textContent: 0,
    duration: 2.5,
    ease: "power4.inOut",
    stagger: {
      each: 0.3,
      onUpdate: function() {
        this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
      },
    }
  });
  document.querySelectorAll('.animation-from-left').forEach(item => {
    gsap.from(item, {
      scrollTrigger: {
        trigger: item,
        start: "top 80%"
      },
      opacity: 0,
      x: -30,
      duration: 2,
      ease: "power3.out",
      stagger: 0.3
    });
  })
  const summaryItems = document.querySelectorAll('.summary-item');
  gsap.from(summaryItems, {
    scrollTrigger: {
      trigger: summaryItems,
      start: "top 80%"
    },
    opacity: 0,
    y: -50,
    duration: 2,
    ease: "power3.out",
    stagger: {
      each: 0.3,
    }
  });
  const facultiesItems = document.querySelectorAll('.faculties-item');
  gsap.from(facultiesItems, {
    scrollTrigger: {
      trigger: facultiesItems,
      start: "top 80%"
    },
    opacity: 0,
    y: -50,
    duration: 2,
    ease: "power3.out",
    stagger: {
      each: 0.3,
    }
  });
  const educativeTexts = document.querySelectorAll('.educative-text');
  gsap.from(educativeTexts, {
    scrollTrigger: {
      trigger: educativeTexts,
      start: "top 80%"
    },
    opacity: 0,
    y: -50,
    duration: 2,
    ease: "power3.out",
    stagger: {
      each: 0.3,
    }
  });


  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  const closeModal = () => {
    success = false;
    error = false;
  }

  let currentRegionPrograms = PROGRAMS;
  let nivelEstudios = [
    { value: 1,	label: 'Estudios primarios', },
    { value: 2,	label: 'Estudios secundarios', },
    { value: 3,	label: 'Bachillerato', },
    { value: 4,	label: 'Formación Profesional', },
    { value: 5,	label: 'Estudios Universitarios', },
    { value: 6,	label: 'Estudios de Posgrado', },
  ]
  switch (region) {
  case 'esp':
    currentRegionPrograms = PROGRAMS;
    break;
  case 'lat':
    currentRegionPrograms = PROGRAMS_LAT;
    break;
  case 'ec':
    currentRegionPrograms = PROGRAMS_EC;
    break;
  }
  var counterAddToCart = false
  var addToCartOrBeginCheckout = function(withModule) {
    return function() {
      var product = currentRegionPrograms.find(p => p.value === Number(program_idSpeciality !== '' ? program_idSpeciality : program_idProduct))
      var grade = GRADES.find(g => g.value === grades)
      if(withModule || (!counterAddToCart && product)){
        var productArea = grade.label
          .replace(/ /g,'_')
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
        var productName = product.label
          .replace(/ /g,'_')
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
        var productType = product.type
        var params = {
          event_name: withModule ? 'begin_checkout' : 'add_to_cart',
          form_name: 'si_lead_product_on_page_body',
          form_type: 'si',
          form_subtype: 'lead',
          form_level: 'product',
          form_display: 'on_page',
          form_position: 'body',
          module: undefined,
          product_id: product.value,
          product_type: productType,
          product_area: productArea,
          product_campus: 'viu',
          product_dedication: undefined,
          product_modality: undefined,
          product_name: productName,
          product_school: productArea,
          ecommerce: {
            currency: 'EUR',
            transaction_id: undefined,
            value: undefined,
            items: [{
              item_name: productName,
              item_id: product.value,
              item_category: productType,
              item_category_2: productArea,
              item_category_3: undefined,
              item_category_4: undefined,
              item_brand: 'viu',
              item_list_name: 'landing/detalle/nosunetuproposito',
              price: 1.0,
              index: undefined,
              quantity: 1,
            }],
          },
        }
        if(withModule){
          params.module = 'body'
        }
        window.emitEvent(params)
      }
      counterAddToCart = true
    }
  }

  var counterFormStart = false
  var formStartOrSuccess = function(event_name) {
    if(event_name === 'form_success' || !counterFormStart) {
      window.emitEvent({
        event_name,
        form_name: 'si_lead_product_on_page_body',
        form_type: 'si',
        form_subtype: 'lead',
        form_level: 'product',
        form_display: 'on_page',
        form_position: 'body',
        module: 'body',
      })
    }
    counterFormStart = true
  }

  var focusEvents = function() {
    addToCartOrBeginCheckout(false)()
    formStartOrSuccess('form_start')
  }

  var generateLead = function(lead_id) {
    var product = currentRegionPrograms.find(p => p.value === Number(program_idSpeciality !== '' ? program_idSpeciality : program_idProduct))
    var grade = GRADES.find(g => g.value === grades)
    var study = nivelEstudios.find(e => e.value === study_level)
    var productArea = grade.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var productName = product.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var studyName = study.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var productType = product.type
    window.emitEvent({
      event_name: 'generate_lead',
      form_name: 'si_lead_product_on_page_body',
      form_type: 'si',
      form_subtype: 'lead',
      form_level: 'product',
      form_display: 'on_page',
      form_position: 'body',
      module: undefined,
      lead_id,
      product_id: product.value,
      product_type: productType,
      product_area: productArea,
      product_campus: 'viu',
      product_dedication: undefined,
      product_modality: undefined,
      product_name: productName,
      product_school: productArea,
      user_age: undefined, // unknown
      user_province: lead_province,
      user_postal_code: undefined, // unknown
      user_studies: studyName,
      user_country: lead_countryISO,
      user_university: undefined, // unknown
      ecommerce: undefined,
    })
  }

  var purchase = function(lead_id, ) {
    var product = currentRegionPrograms.find(p => p.value === Number(program_idSpeciality !== '' ? program_idSpeciality : program_idProduct))
    var grade = GRADES.find(g => g.value === grades)
    var study = nivelEstudios.find(e => e.value === study_level)
    var productArea = grade.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var productName = product.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var studyName = study.label
      .replace(/ /g,'_')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
    var productType = product.type
    window.emitEvent({
      event_name: 'purchase',
      form_name: 'si_lead_product_on_page_body',
      form_type: 'si',
      form_subtype: 'lead',
      form_level: 'product',
      form_display: 'on_page',
      form_position: 'body',
      module: undefined,
      lead_id,
      product_id: product.value,
      product_type: productType,
      product_area: productArea,
      product_campus: 'viu',
      product_dedication: undefined,
      product_modality: undefined,
      product_name: productName,
      product_school: productArea,
      user_age: undefined, // unknown
      user_province: lead_province,
      user_postal_code: undefined, // unknown
      user_studies: studyName,
      user_country: lead_countryISO,
      user_university: undefined, // unknown
      ecommerce: {
        currency: 'EUR',
        transaction_id: lead_id,
        value: 1, // unknown
        items: [{
          item_name: productName,
          item_id: product.value,
          item_category: productType,
          item_category_2: productArea,
          item_category_3: undefined,
          item_category_4: undefined,
          item_brand: 'viu',
          item_list_name: 'landing/detalle/nosunetuproposito',
          price: 1.0,
          index: undefined,
          quantity: 1,
        }],
      },
    })
  }
</script>


<form class="relative flex flex-row flex-wrap lg:pt-6" autocomplete="off">
  {#if loading}
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-orange opacity-60">
      <Circle size="60" color="#D7592B" unit="px" duration="1s"></Circle>
    </div>
  {/if}
  {#if success || error}
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black-opacity">
      <div class="relative flex flex-col items-center w-full max-w-5xl p-12 pt-20 bg-white modal-container rounded-3xl">
        <div class="absolute close-icon top-4 right-4" on:click={closeModal}>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.106689 23.1049L10.4502 12.7613L0.17174 2.48282L2.54762 0.31434L12.8261 10.3854L23.1046 0.31434L25.4805 2.48281L15.202 12.7613L25.5456 23.1049L23.1697 25.4808L12.8261 15.1372L2.4937 25.4808L0.106689 23.1049Z" fill="#e8560f"/>
          </svg>                
        </div>
        <div class="text-center">
          {#if success}
            <div class="mb-2 text-2xl font-bold lg:text-3xl text-orange">
              El registro se ha completado con éxito.
            </div>
            <div class="text-xl">En los próximos días nos pondremos en contacto contigo para informarte sobre el programa seleccionado.</div>
          {/if}
          {#if error}
            <div class="mb-2 text-2xl font-bold lg:text-3xl text-orange">
              Algo ha salido mal
            </div>
            <div class="text-xl">{@html error}</div>
          {/if}
        </div>
        <div class="px-6 py-3 mt-16 font-bold text-center text-white close-icon bg-orange rounded-3xl" style="min-width:200px" on:click={closeModal}>
          Aceptar               
        </div>
      </div>
    </div>
  {/if}
  <Select 
    placeholder="Area de conocimiento *" 
    className="w-full"
    name="grades" 
    bind:val={grades}
    instanceForm={leadForm}
    focus={() => formStartOrSuccess('form_start')}
    items={GRADES}
    onSelectCallback={() => {
      program_idProduct = ''
      program_idSpeciality = ''
    }}
  />
  {#if grades !== ''}
    <Select 
      placeholder="Titulación *" 
      className="w-full"
      name="program_idProduct" 
      bind:val={program_idProduct}
      depends={grades}
      instanceForm={leadForm}
      focus={() => formStartOrSuccess('form_start')}
      items={currentRegionPrograms}
      onSelectCallback={() => {
        program_idSpeciality = ''
      }}
    />
  {/if}
  {#if program_idProduct === 50}
    <Select 
      placeholder="Especialidad *" 
      className="w-full"
      name="program_idSpeciality" 
      bind:val={program_idSpeciality}
      depends={program_idProduct !== 50}
      instanceForm={leadForm}
      focus={() => formStartOrSuccess('form_start')}
      items={SPECIALITIES}
    />
  {/if}
  <Input 
    placeholder="Nombre *" 
    className="w-full" 
    name="lead_name" 
    bind:val={lead_name}
    focus={focusEvents}
    instanceForm={leadForm}
  />
  <Input 
    placeholder="Apellidos *" 
    className="w-full" 
    name="lead_surname" 
    bind:val={lead_surname}
    focus={focusEvents}
    instanceForm={leadForm}
  />
  <Input 
    placeholder="Email *" 
    className="w-full" 
    name="lead_email" 
    bind:val={lead_email}
    focus={focusEvents}
    instanceForm={leadForm}
  />
  <Select 
    placeholder="Sexo *" 
    className="w-full"
    name="lead_sex" 
    bind:val={lead_sex}
    instanceForm={leadForm}
    items={[
      {
        value: 'Man',
        label: 'Hombre',
      },
      {
        value: 'Woman',
        label: 'Mujer',
      }
    ]}
  />
  <Select 
    placeholder="Edad *" 
    className="w-full"
    name="lead_age" 
    bind:val={lead_age}
    instanceForm={leadForm}
    items={_.map(_.range(18,100), age => ({ label: String(age), value: age, }))}
  />
  <Select 
    placeholder="País *" 
    className="w-full"
    name="lead_countryISO" 
    bind:val={lead_countryISO}
    focus={focusEvents}
    instanceForm={leadForm}
    onSelectCallback={updateCountryInfo}
    selectedValue={defaultRegion}
    items={countries}
  />
  {#if lead_provinces.length > 0}
    <Select 
      placeholder="Provincia *"
      className="w-full"
      name="lead_province" 
      bind:val={lead_province}
      focus={focusEvents}
      instanceForm={leadForm}
      items={lead_provinces}
    />
  {/if}
  <Input 
    placeholder="Código postal *" 
    className="w-full"
    name="lead_postCode" 
    bind:val={lead_postCode}
    focus={focusEvents}
    instanceForm={leadForm}
  />
  <Input 
    placeholder="Teléfono *" 
    className="w-full" 
    name="lead_phoneNumber" 
    bind:val={lead_phoneNumber}
    focus={focusEvents}
    instanceForm={leadForm}
  />
  <Select 
    placeholder="Nivel de estudios *" 
    className="w-full"
    name="study_level" 
    bind:val={study_level}
    focus={focusEvents}
    instanceForm={leadForm}
    items={nivelEstudios}
  />
  <div class="h-24 p-3 mt-1 mb-6 overflow-y-scroll text-gray-400 bg-white border frame">
    <p class="text-xs">Universitat Internacional Valenciana – Valencian International University S.L.U, tratará sus datos personales para contactarle e informarle del programa seleccionado de cara a las dos próximas convocatorias del mismo, siendo eliminados una vez facilitada dicha información y/o transcurridas las citadas convocatorias.</p>
    <p class="text-xs">Ud. podrá ejercer los derechos de acceso, supresión, rectificación, oposición, limitación y portabilidad, mediante carta a Universitat Internacional Valenciana – Valencian International University S.L.U - Apartado de Correos 221 de Barcelona, o remitiendo un email a rgpd@universidadviu.com. Asimismo, cuando lo considere oportuno podrá presentar una reclamación ante la Agencia Española de protección de datos.</p>
    <p class="text-xs">Podrá ponerse en contacto con nuestro Delegado de Protección de Datos mediante escrito dirigido a dpo@planeta.es o a Grupo Planeta, At.: Delegado de Protección de Datos, Avda. Diagonal 662-664, 08034 Barcelona.</p>
  </div>
  <div class="flex justify-end w-full">
    <input 
      class="px-6 py-2 text-sm font-bold text-white rounded-full cursor-pointer bg-purple"
      type="submit"
      value="Solicita información"
      on:click|preventDefault={async () => {
        leadForm.validate()
        if ($leadForm.valid) {
          const fields = _.mapValues($leadForm.fields, ({ data: { value }}) => value)
          fields.process_campaignCode = campaignCode

          // edit lead_province to lead_proviceISO
          fields.lead_provinceISO = fields.lead_province
          fields.lead_province = lead_provinces.find(v => v.value === fields.lead_provinceISO)?.label

          loading = true
          addToCartOrBeginCheckout(true)() // begin_checkout
          const response = await axios.post('/wp-json/api/v1/register-lead', fields)
          formStartOrSuccess('form_success') // form_success
          loading = false
          if (response.data.errors === undefined) {
            success = true
            const lead_id = response.data[35].pubsub.process_leadID;
            console.log('SUCCESS', lead_id)
            generateLead(lead_id) // generate_lead
            purchase(lead_id) // purchase
          } else {
            console.log('ERROR', response.data.errors, response.data.errors.length);
            let errorObject = response.data.errors
            let eMessage="Por favor revisa "
            if(errorObject.length === 1){
              eMessage+="el siguiente campo: "
            }else
              eMessage+="los siguientes campos: "
            for (let key in errorObject) {
              let deferror = errorObject[key]
              if(deferror.includes("lead_email")){eMessage+="<br>• El campo <strong>Email</strong> no es válido."};
              if(deferror.includes("lead_name")){eMessage+="<br>• El campo <strong>Nombre</strong> no es válido."};
              if(deferror.includes("lead_surname")){eMessage+="<br>• El campo <strong>Apellidos</strong> no es válido."};
              if(deferror.includes("lead_phoneNumber")){eMessage+="<br>• El campo <strong>Teléfono</strong> no es válido."};
              if(deferror.includes("lead_age`")){eMessage+="<br>• El campo <strong>Edad</strong> no es válido."};
              if(deferror.includes("lead_sex`")){eMessage+="<br>• El campo <strong>Sexo</strong> no es válido."};
              if(deferror.includes("lead_province")){eMessage+="<br>• El campo <strong>Provincia</strong> no es válido."};
              if(deferror.includes("es duplicado")){console.log("`duplicado`")};
            }
            if(errorObject.length===1 && deferror.includes("es duplicado"))eMessage="Gracias, pero el email ya está registrado en nuestra base de datos.<br>En los próximos días nos pondremos en contacto contigo."
              
            error = eMessage
            _.delay(() => error = false, 5000)
          }
        }
      }}
    />
  </div>
</form>

<style lang="scss">
  .frame::-webkit-scrollbar {
      -webkit-appearance: none;
  }

  .frame::-webkit-scrollbar:vertical {
      width: 11px;
  }

  .frame::-webkit-scrollbar:horizontal {
      height: 11px;
  }

  .frame::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid #F6F4F2;
      background-color: rgba(0, 0, 0, .5);
  }
</style>
